import React, { useEffect } from 'react'

// global components
import Header from 'components/Header'
import Footer from 'components/Footer'
import Whatsapp from 'components/Whatsapp'

function PoliticaPrivacidade() {
  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = 'LB STORE - Política de Privacidade'
  }, [])

  return (
    <div className='flex min-h-screen w-full flex-col bg-white text-gray-800'>
      <Header />

      <main className='mt-20 flex min-h-svh flex-grow items-start justify-center px-6 py-16'>
        <article className='w-full max-w-4xl'>
          {/* Título */}
          <h1 className='mb-6 text-4xl font-light tracking-wide text-gray-900 md:text-5xl'>Política de Privacidade</h1>
          <div className='mb-10 h-[2px] w-20 rounded bg-[#491C47]'></div>

          {/* Conteúdo */}
          <div className='prose prose-neutral max-w-none text-lg leading-relaxed text-gray-700'>
            <section id='coleta' className='scroll-mt-24'>
              <h2 className='mb-4 text-2xl font-medium text-gray-900 md:text-3xl'>Coleta e uso de informações</h2>
              <p>
                Todas as interações e compras realizadas com a LB STORE acontecem exclusivamente por meio do{' '}
                <span className='font-semibold'>WhatsApp</span>. Durante o atendimento poderemos solicitar informações
                pessoais necessárias para emissão do pedido, confirmação de pagamento e envio do produto, como nome
                completo, endereço, telefone e dados de entrega.
              </p>
              <p>
                Essas informações são utilizadas apenas para o processamento do pedido, comunicação com o cliente e
                atendimento pós-venda. Não coletamos dados automaticamente por meio de nosso site.
              </p>
              <p>
                Ao compartilhar seus dados durante o atendimento entendemos que você está de acordo com sua utilização
                para as finalidades mencionadas.
              </p>
            </section>

            <section id='consentimento' className='mt-10 scroll-mt-24'>
              <h2 className='mb-4 text-2xl font-medium text-gray-900 md:text-3xl'>Consentimento</h2>
              <h3 className='mb-2 text-xl font-semibold'>Como vocês obtêm meu consentimento?</h3>
              <p>
                Quando você fornece informações pessoais como nome, telefone e endereço durante o atendimento via
                WhatsApp para completar uma compra, confirmar pagamento ou combinar detalhes de entrega, entendemos que
                você consente com a coleta e o uso dessas informações para tais finalidades.
              </p>
              <h3 className='mb-2 mt-6 text-xl font-semibold'>Como retirar meu consentimento?</h3>
              <p>
                Se, após nos fornecer seus dados, você mudar de ideia, pode retirar seu consentimento a qualquer momento
                entrando em contato em{' '}
                <a
                  href='https://api.whatsapp.com/send?phone=5543996160770&text=Ol%C3%A1%2C%20Vim%20pelo%20site.'
                  target='_blank'
                  className='hover:underline'
                >
                  (43) 99616-0770
                </a>{' '}
                ou nos enviando correspondência para:
              </p>
              <address className='mt-2 not-italic'>R. Aparício Bitencourt, 285 - Ivaiporã, PR, 86870-000</address>
            </section>

            <section id='divulgacao' className='mt-10 scroll-mt-24'>
              <h2 className='mb-4 text-2xl font-medium text-gray-900 md:text-3xl'>Divulgação</h2>
              <p>
                Podemos divulgar suas informações pessoais caso sejamos obrigados pela lei a fazê-lo ou se você violar
                nossos Termos de Serviço.
              </p>
            </section>

            <section id='terceiros' className='mt-10 scroll-mt-24'>
              <h2 className='mb-4 text-2xl font-medium text-gray-900 md:text-3xl'>Serviços de terceiros</h2>
              <p>
                Utilizamos fornecedores terceirizados que coletam, usam e divulgam informações estritamente no
                necessário para executar os serviços que nos prestam, como emissão e processamento de pagamentos por
                link, logística e sistemas de mensageria.
              </p>
              <p>
                Esses fornecedores possuem políticas próprias de privacidade que recomendamos consultar para entender
                como seus dados serão tratados por cada um deles.
              </p>
              <p>
                Ao ser direcionado(a) para o ambiente de pagamento externo ou outras plataformas de atendimento, você
                deixa de estar regido por esta Política e passa a se submeter às políticas dos respectivos terceiros.
              </p>
            </section>

            <section id='seguranca' className='mt-10 scroll-mt-24'>
              <h2 className='mb-4 text-2xl font-medium text-gray-900 md:text-3xl'>Segurança</h2>
              <p>
                Adotamos medidas razoáveis e práticas alinhadas ao mercado para proteger suas informações contra perda,
                uso indevido, acesso, divulgação, alteração ou destruição não autorizados.
              </p>
              <p>
                Os pagamentos realizados por link são processados em ambiente seguro diretamente pelo provedor de
                pagamento externo. Não armazenamos integralmente dados sensíveis de cartão em nossos sistemas.
              </p>
              <div className='mt-4 rounded-xl border border-gray-200 p-4 text-base'>
                <p className='mb-2 font-semibold'>Boas práticas para sua segurança</p>
                <ul className='list-inside list-disc space-y-1'>
                  <li>Confirme se o link de pagamento foi enviado por nossos canais oficiais no WhatsApp.</li>
                  <li>Verifique o cadeado HTTPS e o domínio antes de inserir dados.</li>
                  <li>Não compartilhe códigos de confirmação ou senhas.</li>
                </ul>
              </div>
            </section>

            <section id='alteracoes' className='mt-10 scroll-mt-24'>
              <h2 className='mb-4 text-2xl font-medium text-gray-900 md:text-3xl'>
                Alterações nesta Política de Privacidade
              </h2>
              <p>
                Podemos modificar esta Política a qualquer momento. Por favor, revise-a com frequência. Alterações
                entram em vigor imediatamente após a publicação no site.
              </p>
              <p>
                Em caso de aquisição ou fusão da loja com outra empresa, suas informações podem ser transferidas aos
                novos controladores para continuidade das operações.
              </p>
            </section>

            <section id='whatsapp' className='mt-10 scroll-mt-24'>
              <h2 className='mb-4 text-2xl font-medium text-gray-900 md:text-3xl'>
                Compra via WhatsApp e Pagamentos por Link
              </h2>
              <p>
                Todas as compras são concluídas exclusivamente por atendimento humano no{' '}
                <span className='font-semibold'>WhatsApp</span>. Após o fechamento do pedido nosso time enviará o link
                de pagamento diretamente na conversa oficial da LB STORE.
              </p>
              <p>
                O pagamento é processado em ambiente seguro por um provedor externo de confiança e nenhuma informação
                sensível de cartão é armazenada pela LB STORE.
              </p>
              <p>
                Ao clicar no link você será direcionado(a) para uma página de pagamento fora do WhatsApp. Recomendamos
                conferir o endereço (URL) e o cadeado de segurança no navegador antes de inserir qualquer dado.
              </p>
              <p>
                Após a confirmação do pagamento pelo provedor daremos sequência ao seu pedido e manteremos você
                informado(a) sobre o status da entrega pelos canais oficiais.
              </p>
            </section>

            <section id='contato' className='mt-10 scroll-mt-24'>
              <h2 className='mb-4 text-2xl font-medium text-gray-900 md:text-3xl'>Contato</h2>
              <p>Em caso de dúvidas sobre esta Política entre em contato:</p>
              <p>
                <a
                  href='https://api.whatsapp.com/send?phone=5543996160770&text=Ol%C3%A1%2C%20Vim%20pelo%20site.'
                  target='_blank'
                  className='hover:underline'
                >
                  (43) 99616-0770
                </a>
              </p>
              <address className='not-italic'>R. Aparício Bitencourt, 285 - Ivaiporã, PR, 86870-000</address>
            </section>
          </div>
        </article>
      </main>

      <Footer />
      <Whatsapp />
    </div>
  )
}

export default PoliticaPrivacidade
